module.exports = __webpack_public_path__ + "static/media/creditCards-visa.6bd3d07a.svg";